import {Theme, ThemeOptions} from '@mui/material/styles';
import { tokens } from '../tokens/tokens';

export const buildTypographyTheme = (
    bp: Theme
): ThemeOptions => ({
    typography: {
        fontFamily: tokens.fontFamily.sans,
        fontSize: 14,
        h1: {
            fontSize: tokens.fontSize['4xl'],
            fontWeight: tokens.fontWeight.bold,
            lineHeight: 1.25,

            [bp.breakpoints.down('smPlus')]: {
                fontSize: tokens.fontSize['3xl'],
            },
        },
        h2: {
            fontSize: tokens.fontSize['3xl'],
            fontWeight: tokens.fontWeight.semibold,
            lineHeight: 1.25,

            [bp.breakpoints.down('smPlus')]: {
                fontSize: tokens.fontSize['2xl'],
            },
        },
        h3: {
            fontSize: tokens.fontSize['2xl'],
            fontWeight: tokens.fontWeight.semibold,
            lineHeight: 1.25,

            [bp.breakpoints.down('smPlus')]: {
                fontSize: tokens.fontSize.xl,
            },
        },
        h4: {
            fontSize: tokens.fontSize.xl,
            fontWeight: tokens.fontWeight.semibold,

            [bp.breakpoints.down('smPlus')]: {
                fontSize: tokens.fontSize.lg,
            },
        },
        h5: {
            fontSize: tokens.fontSize.lg,
            fontWeight: tokens.fontWeight.semibold,

            [bp.breakpoints.down('smPlus')]: {
                fontSize: tokens.fontSize.base,
            },
        },
        h6: {
            fontSize: tokens.fontSize.base,
            fontWeight: tokens.fontWeight.semibold,

            [bp.breakpoints.down('smPlus')]: {
                fontSize: tokens.fontSize.sm,
            },
        },
        body1: {
            fontSize: tokens.fontSize.base,
            lineHeight: 1.5,

            [bp.breakpoints.down('smPlus')]: {
                fontSize: tokens.fontSize.sm,
            },
        },
        body2: {
            fontSize: tokens.fontSize.sm,
            lineHeight: 1.5,

            [bp.breakpoints.down('smPlus')]: {
                fontSize: tokens.fontSize.xs,
            },
        },
        caption: {
            fontSize: tokens.fontSize.xs
        },
        button: {
            textTransform: 'none',
            fontWeight: tokens.fontWeight.medium,
            fontSize: tokens.fontSize.base,

            [bp.breakpoints.down('smPlus')]: {
                fontSize: tokens.fontSize.sm,
            },
        },
    },
});